import repository from '@/repositories/Repository'

const resource = '/store_groups'

export default {
  get(companyCode) {
    return repository.bizoo.get(`${resource}/${companyCode}`).then(r => r.data)
  },
}
